export const DEFAULT_SCHOOL_TIME_ZONE = "Asia/Karachi";

export function schoolDayKey(value, timeZone = DEFAULT_SCHOOL_TIME_ZONE) {
  const date = value instanceof Date ? value : new Date(value || Date.now());
  if (Number.isNaN(date.getTime())) return "";
  return new Intl.DateTimeFormat("en-CA", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);
}

export function schoolClockParts(value, timeZone = DEFAULT_SCHOOL_TIME_ZONE) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone,
    hourCycle: "h23",
    hour: "2-digit",
    minute: "2-digit",
  }).formatToParts(date);
  const bag = {};
  parts.forEach((part) => {
    if (part.type !== "literal") bag[part.type] = part.value;
  });
  let hour = Number(bag.hour);
  if (hour === 24) hour = 0;
  return { hour, minute: Number(bag.minute) };
}

export function isWeekendKey(key) {
  const [year, month, day] = String(key || "").split("-").map(Number);
  if (!year || !month || !day) return false;
  const weekday = new Date(Date.UTC(year, month - 1, day)).getUTCDay();
  return weekday === 0 || weekday === 6;
}

export function isOpenWeekend(key, duties) {
  if (!isWeekendKey(key)) return false;
  return (duties || []).some((item) => {
    const start = item.startKey || "";
    const end = item.endKey || start;
    return start && start <= key && key <= end;
  });
}

export function schoolToday(timeZone = DEFAULT_SCHOOL_TIME_ZONE) {
  const key = schoolDayKey(new Date(), timeZone);
  const [year, month, day] = key.split("-").map(Number);
  return { key, year, month, day };
}

export function schoolZoneOptions() {
  const zones =
    typeof Intl.supportedValuesOf === "function" ? Intl.supportedValuesOf("timeZone") : [DEFAULT_SCHOOL_TIME_ZONE];
  if (!zones.includes(DEFAULT_SCHOOL_TIME_ZONE)) zones.unshift(DEFAULT_SCHOOL_TIME_ZONE);
  return zones;
}
